"use strict";
/// <reference path="./PropertyPage.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommitObject = exports.ValidationObject = exports.CommitSuccess = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const GuiEvents_1 = require("../../javascript/GuiEvents");
require("../../javascript/GuiTriggers");
const Utilities_1 = require("../../javascript/Utilities");
require("../../less/PropertyPage.less");
const PropertyPageControls_1 = require("./PropertyPageControls");
const PropertyPageModel_1 = require("../../model/PropertyPageModel");
const Instance_1 = require("../../model/Instance");
const Base_1 = require("../../model/Base");
/**
* Specifies the result of a successful commit. Either new document was created or existing document was saved.
*/
var CommitSuccess;
(function (CommitSuccess) {
    CommitSuccess[CommitSuccess["Saved"] = 1] = "Saved";
    CommitSuccess[CommitSuccess["Created"] = 2] = "Created";
    CommitSuccess[CommitSuccess["NoChanges"] = 3] = "NoChanges";
})(CommitSuccess = exports.CommitSuccess || (exports.CommitSuccess = {}));
/**
* Object specifying callback results of commit
*/
class ValidationObject {
}
exports.ValidationObject = ValidationObject;
/**
* Object specifying callback results of commit
*/
class CommitObject {
    constructor() {
        this.fileGUIDs = [];
        this.success = (currentInstance, result) => { return; };
        this.fail = () => { return; };
        this.cleanUp = () => { return; };
        this.updatePropertyPageAfterCommit = false;
    }
}
exports.CommitObject = CommitObject;
(($) => {
    let methods = {
        init(options) {
            return this.each(function () {
                const $this = $(this);
                const synData = $this.data('synPropertyPage');
                if (!synData) {
                    // Set id if none has been provided - this is necessary for uniqueness of selectors of
                    // controls inside PropertyPage. This is a workaround for what is most likely a bug.
                    if (!$this.attr("id"))
                        $this.attr("id", Utilities_1.synUtil.getGUID(true));
                    $this.data('synPropertyPage', $.extend({
                        propertypageControlsWsUrl: Utilities_1.synUtil.getWSUrl("PropertypageControls"),
                        propertypageControlsTemplateWsUrl: Utilities_1.synUtil.getWSUrl("PropertypageControlsTemplate"),
                        PropertypageMandatoryFieldsWsUrl: Utilities_1.synUtil.getWSUrl("PropertypageMandatoryFields"),
                        checkForUnsavedChanges: false,
                        useSidebar: false,
                        raiseBeforeVersionChanged: false,
                        layout: "absolute"
                    }, options));
                    const synData = $this.data("synPropertyPage");
                    let optionsDiv = $("<div style='position:relative' id='" + $this.attr("id") + "_opt'></div>").appendTo($this);
                    synData.versionsDiv = $("<div style='position:relative' id='" + $this.attr("id") + "_ver'></div>").appendTo(optionsDiv);
                    synData.propPageDiv = $("<div class='ppContainer' style='position:relative' id='" + $this.attr("id") + "_pp'></div>").appendTo($this);
                    $this.trigger("beginInit");
                    $this.addClass("synPropertyPage");
                    $this.trigger("endInit");
                }
            });
        },
        destroy() {
            return this.each(function () {
                const $this = $(this);
                const synData = $this.data('synPropertyPage');
                if (synData && synData.controls) {
                    $.each(synData.controls.allControls, function (index, control) {
                        control.destroy();
                    });
                }
                $(this).off("beginInit");
                $(this).off("initSuccess");
                $(this).off("endInit");
                $(this).off("controlsInitialized");
                $(this).off("valuesChanged");
                $(this).off("valuesChangedManually");
                $(this).off("valuesReverted");
                $(this).off("valuesRevertedManually");
                $(this).off("instanceReceived");
                $(this).off("instanceChanged");
                $(this).off("needsFullRefresh");
                $(this).off("beginSetInstance");
                $(this).off("endSetInstance");
                $(this).off("beginSetTemplate");
                $(this).off("endSetTemplate");
                $(this).off("beginCommit");
                $(this).off("endCommit");
                $(this).off("ignoredValue");
                $(this).off("unsavedChangesObsolete");
                $this.html("");
                $this.removeData('synPropertyPage');
            });
        },
        getLayout() {
            const $this = $(this);
            const synData = $this.data('synPropertyPage');
            return synData.layout;
        },
        // "absolute", "table"
        setLayout(layout) {
            return this.each(function () {
                let l = layout;
                if (l !== "absolute" && l !== "table")
                    l = "absolute";
                const $this = $(this);
                const synData = $this.data('synPropertyPage');
                if (synData.layout !== l) {
                    synData.layout = l;
                    ApplyLayout($this);
                }
            });
        },
        // Options: mode, id
        setInstance(optionsJSON) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let $this = $(this);
                let options = yield PropertyPageModel_1.PropertyPageSetInstanceOptions.fromJSON(optionsJSON);
                return yield $this.synPropertyPage("setInstanceWithOptions", options);
            });
        },
        setInstanceWithOptions(options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let showVersions = typeof options.showVersions === "undefined" ? true : options.showVersions;
                return yield this.each(function () {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        const $this = $(this);
                        const synData = $this.data('synPropertyPage');
                        $this.removeClass("initComplete");
                        if (options.propertyPage) {
                            let propertyPage = options.propertyPage;
                            synData.modeFromServer = propertyPage.mode;
                            synData.typeId = propertyPage.instance.items["cgdocument.typeid"].valueToNumber(0);
                            if (options.parentId)
                                synData.parentId = options.parentId;
                            if (options.parentRelId)
                                synData.parentRelId = options.parentRelId;
                            synData.propPageDiv.html("");
                            synData.options = propertyPage.options;
                            synData.version = propertyPage.instance.items["cgdocument.version"].value;
                            InitControls($this, propertyPage, synData.tabindexOffset);
                            if (synData.modeFromServer !== Base_1.PropertyPageMode.New)
                                SetVersions($this, propertyPage.instance);
                            synData.versionsDiv.css("display", (showVersions && propertyPage.showVersions ? "" : "none"));
                            $this.synPropertyPage("fixBackgroundPosition");
                        }
                        else {
                            if (!options.mode)
                                $.errorDialog("show", { ErrorDisplayMessage: "Propertypage mode must be specified!" });
                            if (!options.id)
                                $.errorDialog("show", { ErrorDisplayMessage: "ID must be specified!" });
                            let requestOptions = {
                                instance: options.id,
                            };
                            let clear = false;
                            let components = options.id.split("|");
                            if (synData.typeId) {
                                let typeid = components[2];
                                if (synData.typeId.toString() !== typeid)
                                    clear = true;
                            }
                            else
                                clear = true;
                            if (options.clear != undefined && options.clear === true) // Hotfix for fush refresh
                                clear = true;
                            options.mode = (options.verCur === false ? Base_1.PropertyPageMode.View : options.mode);
                            requestOptions.mode = options.mode.toString();
                            if (options.tagName)
                                requestOptions.tagName = options.tagName.toString();
                            if (!synData.initialMode) {
                                clear = true;
                                synData.initialMode = options.mode;
                            }
                            else if (synData.initialMode !== options.mode)
                                clear = true;
                            // For preview, initial mode not valid when switching between tree nodes
                            if (options.overrideInitialMode)
                                synData.initialMode = options.mode;
                            if (options.showVersions != undefined)
                                synData.showVersions = options.showVersions;
                            if (components.length === 4) {
                                // instanzid|docid|typeid|version was specified.
                                // Mode may change regardless of mode supplied.
                                // PropertyPage has to be refreshed to be sure!
                                clear = true;
                            }
                            if (clear)
                                $this.trigger("needsFullRefresh", [synData.typeId]);
                            else
                                requestOptions.getControls = "false";
                            $this.trigger("beginSetInstance");
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: synData.propertypageControlsWsUrl,
                                requestData: requestOptions,
                                done: yield function (propertyPageJSON) {
                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                        let propertyPage = yield PropertyPageModel_1.PropertyPageModel.fromJSON(propertyPageJSON);
                                        synData.modeFromServer = propertyPage.mode;
                                        let instance = propertyPage.instance;
                                        $this.trigger("instanceReceived", [instance]);
                                        synData.typeId = instance.items["cgdocument.typeid"].valueToNumber(0);
                                        let oldInst = $this.synPropertyPage("getInstance");
                                        let versionChanged = false;
                                        synData.versionsDiv.css("display", (showVersions && propertyPage.showVersions ? "" : "none"));
                                        if (synData.version) {
                                            if (synData.version != instance.items["cgdocument.version"].value) {
                                                synData.version = instance.items["cgdocument.version"].value;
                                                $this.trigger("versionChanged", [{
                                                        id: instance.id.value,
                                                        version: synData.version,
                                                        verCur: instance.items["cgdocument.vercur"].value
                                                    }]);
                                                versionChanged = true;
                                            }
                                        }
                                        else
                                            synData.version = instance.items["cgdocument.version"].value;
                                        if (clear) {
                                            synData.propPageDiv.html("");
                                            synData.options = propertyPage.options;
                                            InitControls($this, propertyPage, synData.tabindexOffset);
                                            if (synData.modeFromServer !== Base_1.PropertyPageMode.New)
                                                SetVersions($this, instance);
                                        }
                                        else {
                                            SetValuesToControls($this, instance);
                                            SetNotNullFields($this, propertyPage.notNullFields);
                                            if (synData.modeFromServer !== Base_1.PropertyPageMode.New)
                                                SetVersions($this, instance);
                                        }
                                        if (options.done)
                                            options.done();
                                        if (!versionChanged)
                                            $this.trigger("instanceChanged", [instance]);
                                        $this.synPropertyPage("fixBackgroundPosition");
                                    });
                                },
                                cleanUp() {
                                    if (options.cleanUp)
                                        options.cleanUp();
                                    $this.trigger("endSetInstance");
                                    $this.addClass("initComplete");
                                    CheckForUnsavedChanges($this);
                                }
                            });
                        }
                    });
                });
            });
        },
        setTemplate(options) {
            return this.each(function () {
                const $this = $(this);
                const synData = $this.data('synPropertyPage');
                $this.removeClass("initComplete");
                if (!options.mode)
                    $.errorDialog("show", { ErrorDisplayMessage: "Propertypage mode must be specified!" });
                if (!options.typeId)
                    $.errorDialog("show", { ErrorDisplayMessage: "typeId must be specified!" });
                let requestOptions = {
                    typeId: options.typeId.toString(),
                    mode: options.mode.toString()
                };
                if (options.parentId)
                    requestOptions.parentId = options.parentId.toString();
                if (options.parentRelId)
                    requestOptions.parentRelId = options.parentRelId.toString();
                if (options.tagName)
                    requestOptions.tagName = options.tagName.toString();
                if (typeof options.ignoreAllReadOnlyFields !== "undefined")
                    requestOptions.ignoreAllReadOnlyFields = options.ignoreAllReadOnlyFields;
                let clear = false;
                if (synData.typeId) {
                    if (synData.typeId !== options.typeId)
                        clear = true;
                }
                else
                    clear = true;
                if (!synData.initialMode) {
                    clear = true;
                    synData.initialMode = options.mode;
                }
                else if (synData.initialMode !== options.mode)
                    clear = true;
                if (!clear)
                    requestOptions.getControls = "false";
                $this.trigger("beginSetTemplate");
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: synData.propertypageControlsTemplateWsUrl,
                    requestData: requestOptions,
                    done(propertyPageJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let propertyPage = yield PropertyPageModel_1.PropertyPageModel.fromJSON(propertyPageJSON);
                            synData.modeFromServer = propertyPage.mode;
                            synData.typeId = propertyPage.instance.items["cgdocument.typeid"].valueToNumber(0);
                            $this.trigger("instanceReceived", [propertyPage.instance]);
                            if (clear) {
                                synData.propPageDiv.html("");
                                synData.options = propertyPage.options;
                                InitControls($this, propertyPage, synData.tabindexOffset);
                            }
                            else {
                                SetValuesToControls($this, propertyPage.instance);
                                SetNotNullFields($this, propertyPage.notNullFields);
                            }
                            if (options.parentId)
                                synData.parentId = options.parentId;
                            if (options.parentRelId)
                                synData.parentRelId = options.parentRelId;
                            if (options.done)
                                options.done();
                            $this.trigger("instanceChanged", [propertyPage.instance]);
                            $this.synPropertyPage("fixBackgroundPosition");
                        });
                    },
                    cleanUp() {
                        if (options.cleanUp)
                            options.cleanUp();
                        $this.trigger("endSetTemplate");
                        $this.addClass("initComplete");
                        CheckForUnsavedChanges($this);
                    }
                });
            });
        },
        fixBackgroundPosition() {
            const $this = $(this);
            const synData = $this.data('synPropertyPage');
            if (synData && synData.propertyPageOptions && synData.propertyPageOptions.bgFloat) {
                let rect = synData.propPageDiv[0].getBoundingClientRect();
                synData.propPageDiv.css("background-position", rect.left.toFixed(2) + "px " + rect.top.toFixed(2) + "px");
            }
        },
        getInstance(clearDynInvisibleValues) {
            const $this = $(this);
            const synData = $this.data('synPropertyPage');
            if (!synData)
                return undefined;
            let fac = synData.controlFactory;
            if (!fac)
                return undefined;
            return fac.getCurrentInstance(clearDynInvisibleValues);
        },
        getVersion() {
            const $this = $(this);
            let inst = $this.synPropertyPage("getInstance");
            if (!inst)
                return undefined;
            return {
                version: inst.items["cgdocument.version"].valueAsNumber,
                verCur: inst.items["cgdocument.vercur"].valueAsBoolean
            };
        },
        changeInstance(changeSet) {
            const $this = $(this);
            const synData = $this.data('synPropertyPage');
            $this.synPropertyPage("fixBackgroundPosition");
            // changeSet only needs to contain changed properties. For changed FT fields, only pass their presented values.
            return this.each(function () {
                if (changeSet instanceof Instance_1.Instance) {
                    for (let key in changeSet.items) {
                        let item = changeSet.items[key];
                        if (!item.isEmpty) {
                            if (!item.valueIsArray) {
                                if (typeof item.value === "string") {
                                    let coll = synData.controls.controlsByFieldName[key];
                                    if (!coll || !coll.Input || !coll.Input.maxTextLength || coll.Input.maxTextLength == -1)
                                        continue;
                                    // check for max text length and splice strings, if too long
                                    if (coll.Input.maxTextLength < item.value.length)
                                        changeSet.items[key].value = item.value.substr(0, coll.Input.maxTextLength);
                                }
                            }
                        }
                    }
                }
                else {
                    for (let key of Object.keys(changeSet)) {
                        let val = changeSet[key];
                        if (!val || !val.length)
                            continue;
                        let coll = synData.controls.controlsByFieldName[key];
                        if (!coll || !coll.Input || !coll.Input.maxTextLength || coll.Input.maxTextLength == -1)
                            continue;
                        // check for max text length and splice strings, if too long
                        if (coll.Input.maxTextLength < val.length)
                            changeSet[key] = val.substr(0, coll.Input.maxTextLength);
                    }
                }
                synData.controlFactory.changeInstance(changeSet);
                synData.controlFactory.raiseOnChange(synData.controlFactory, false);
            });
        },
        refresh(clear) {
            return this.each(function () {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    const $this = $(this);
                    const synData = $this.data('synPropertyPage');
                    let oldInst = $this.synPropertyPage("getInstance");
                    if (oldInst) {
                        if (synData.modeFromServer !== Base_1.PropertyPageMode.Search && oldInst.items["cgdocument.docid"].value) {
                            yield $this.synPropertyPage("setInstance", {
                                id: oldInst.id.value,
                                mode: synData.initialMode,
                                showVersions: synData.showVersions == undefined ? true : synData.showVersions,
                                clear: clear,
                            });
                        }
                        else {
                            let options = {
                                typeId: synData.typeId,
                                mode: synData.initialMode,
                                showVersions: synData.showVersions == undefined ? true : synData.showVersions,
                            };
                            if (synData.parentId)
                                options.parentId = synData.parentId.toString();
                            if (synData.parentRelId)
                                options.parentRelId = synData.parentRelId.toString();
                            if (clear)
                                options.clear = clear;
                            $this.synPropertyPage("setTemplate", options);
                        }
                    }
                });
            });
        },
        deleteUnsavedChanges() {
            return this.each(function () {
                const $this = $(this);
                const synData = $this.data("synPropertyPage");
                if (synData && synData.controlFactory)
                    DeleteUnsavedChanges($this, synData.controlFactory.getCurrentInstance());
            });
        },
        instanceHasChanged() {
            const $this = $(this);
            const synData = $this.data('synPropertyPage');
            return synData.controlFactory.instanceHasChanged([]);
        },
        getChangedFields() {
            const $this = $(this);
            const synData = $this.data('synPropertyPage');
            let changedArr = [];
            synData.controlFactory.instanceHasChanged(changedArr);
            return changedArr;
        },
        lock() {
            return this.each(function () {
                const synData = $(this).data("synPropertyPage");
                $.each(synData.controls.allControls, (idx, control) => {
                    control.enable(false);
                });
            });
        },
        commitChanges(commitObject, tagName) {
            commitObject = $.extend(true, new CommitObject(), commitObject);
            $(this).trigger("controlLogFullLicense");
            return this.each(function () {
                const $this = $(this);
                const synData = $this.data('synPropertyPage');
                let oldInst = $this.synPropertyPage("getInstance");
                // Validation is only possible if:
                // * PropertyPage is not empty (has template or existing instance)
                // * mode is either Edit or New
                if (oldInst
                    && (synData.modeFromServer === Base_1.PropertyPageMode.New || synData.modeFromServer === Base_1.PropertyPageMode.Edit)) {
                    $this.synPropertyPage("validate", {
                        validationFailed: (errorMsg) => {
                            if (commitObject && commitObject.validationFailed)
                                commitObject.validationFailed(errorMsg);
                            else
                                Utilities_1.synUtil.Notifications.error(errorMsg.replace(/[\r]?\n/g, "<br/>"));
                            if (commitObject)
                                commitObject.cleanUp();
                        },
                        validationSuccess() {
                            let instance = $this.synPropertyPage("getInstance", true);
                            GuiEvents_1.GuiEvents.BeforeSave(instance, (result) => {
                                if (result) {
                                    let instanceJSON = instance.toJSON();
                                    let requestOptions = {};
                                    $this.trigger("modifyInstanceBeforeCommit", [instanceJSON]);
                                    requestOptions.instance = JSON.stringify(instanceJSON);
                                    if (commitObject && commitObject.fileGUIDs.length)
                                        requestOptions.fileGUIDs = commitObject.fileGUIDs.join(";");
                                    else if (commitObject && commitObject.templateId)
                                        requestOptions.templateId = commitObject.templateId;
                                    if (synData.modeFromServer === Base_1.PropertyPageMode.New) {
                                        // Only save if changed
                                        $this.trigger("beginCommit");
                                        if (synData.parentId)
                                            requestOptions.parentId = synData.parentId;
                                        if (synData.parentRelId)
                                            requestOptions.parentRelId = synData.parentRelId;
                                        Utilities_1.synUtil.getAJAXData({
                                            method: "PUT",
                                            url: Utilities_1.synUtil.getWSUrl("InstanceCreate"),
                                            requestData: requestOptions,
                                            done(data) {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    let instance = yield Instance_1.Instance.fromJSON(data);
                                                    if (commitObject && commitObject.updatePropertyPageAfterCommit) {
                                                        yield $this.synPropertyPage("setInstance", {
                                                            mode: Base_1.PropertyPageMode.Edit,
                                                            id: instance.id.value,
                                                            tagName: (tagName != undefined) ? tagName : "default"
                                                        });
                                                    }
                                                    window.waitConditions.set("propertyPageCommitted");
                                                    if (commitObject)
                                                        commitObject.success(instance, CommitSuccess.Created);
                                                });
                                            },
                                            fail(jqXHR, textStatus, errorThrown, url) {
                                                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                                if (commitObject)
                                                    commitObject.fail();
                                            },
                                            cleanUp() {
                                                if (commitObject)
                                                    commitObject.cleanUp();
                                                $this.trigger("endCommit");
                                            }
                                        });
                                    }
                                    else if (synData.modeFromServer === Base_1.PropertyPageMode.Edit) {
                                        if ($this.synPropertyPage("instanceHasChanged")) {
                                            $this.trigger("beginCommit");
                                            Utilities_1.synUtil.getAJAXData({
                                                method: "POST",
                                                url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                                                requestData: requestOptions,
                                                done(data) {
                                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                        let instanceSaved = yield Instance_1.Instance.fromJSON(data);
                                                        if (commitObject.updatePropertyPageAfterCommit !== false) {
                                                            yield $this.synPropertyPage("setInstance", {
                                                                mode: synData.initialMode,
                                                                id: instanceSaved.id.value
                                                            });
                                                        }
                                                        window.waitConditions.set("propertyPageCommitted");
                                                        commitObject.success(instanceSaved, CommitSuccess.Saved);
                                                    });
                                                },
                                                fail(jqXHR, textStatus, errorThrown, url) {
                                                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                                    commitObject.fail();
                                                },
                                                cleanUp() {
                                                    commitObject.cleanUp();
                                                    $this.trigger("endCommit");
                                                }
                                            });
                                        }
                                        else {
                                            commitObject.success(instance, CommitSuccess.NoChanges);
                                            commitObject.cleanUp();
                                        }
                                    }
                                    else {
                                        commitObject.success(instance, CommitSuccess.NoChanges);
                                        commitObject.cleanUp();
                                    }
                                }
                                else
                                    commitObject.cleanUp();
                            });
                        }
                    });
                }
            });
        },
        validate(obj) {
            const $this = $(this);
            const synData = $this.data('synPropertyPage');
            let validationFailed = false;
            let failedFieldTitlesMap = {};
            let inst = $this.synPropertyPage("getInstance");
            if (synData.notNullFields) {
                $.each(synData.notNullFields, function (idx, notnullField) {
                    if (obj.ignoreFields && $.inArray(notnullField, obj.ignoreFields) >= 0)
                        return true;
                    let text = synData.controlFactory.getDisplayTitleForValidationErrors(notnullField);
                    let coll = synData.controls.controlsByFieldName[notnullField];
                    if (coll && coll.Input) {
                        if (coll.Input.getValue() == undefined) {
                            let fieldValidationFailed = false;
                            if (coll.Input.field.isFTRepresentativeField) {
                                if (inst.items[coll.Input.field.presentedField].isEmpty)
                                    fieldValidationFailed = true;
                            }
                            else
                                fieldValidationFailed = true;
                            if (fieldValidationFailed) {
                                failedFieldTitlesMap[text] = true;
                                validationFailed = true;
                            }
                        }
                    }
                    else {
                        let collArr = synData.controls.controlsByPresentedFieldName[notnullField];
                        if (collArr && collArr.length) {
                            if (inst.items[notnullField].isEmpty) {
                                failedFieldTitlesMap[text] = true;
                                validationFailed = true;
                            }
                        }
                    }
                });
            }
            if (validationFailed) {
                // Format error message
                let failedFieldTitles = Object.keys(failedFieldTitlesMap).sort((a, b) => a.localeCompare(b));
                let msg = kendo.format(synData.notNullFieldsErrorFormat, "\n" + failedFieldTitles.join("\n"));
                msg = msg.replace(/\\r/g, "\r");
                msg = msg.replace(/\\n/g, "\n");
                if (obj.validationFailed)
                    obj.validationFailed(msg);
                else
                    Utilities_1.synUtil.Notifications.error(msg.replace(/[\r]?\n/g, "<br/>"));
            }
            else
                obj.validationSuccess();
        },
        getControlFactory() {
            const $this = $(this);
            const synData = $this.data('synPropertyPage');
            return synData.controlFactory;
        }
    };
    $.fn.synPropertyPage = function (method) {
        if (methods[method])
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        else if (typeof method === 'object' || !method)
            return methods.init.apply(this, arguments);
        else
            $.error('Method ' + method + ' does not exist on jQuery.synPropertyPage');
    };
    function ApplyLayout($this) {
        const synData = $this.data('synPropertyPage');
        synData.propPageDiv.css({ width: "", height: "" });
        if (synData.layout === "absolute") {
            synData.propPageDiv.removeClass("ppTableLayout").addClass("ppAbsoluteLayout");
            let leftBound = 0;
            let bottomBound = 0;
            if (synData.controls) {
                $.each(synData.controls.controlsByFieldName, function (idx, coll) {
                    for (let key in coll) {
                        if (coll.hasOwnProperty(key)) {
                            let elem = coll[key];
                            synData.propPageDiv.append(elem.getDOMControl());
                            elem.setLayout("absolute");
                            leftBound = Math.max(leftBound, elem.width + elem.left);
                            bottomBound = Math.max(bottomBound, elem.height + elem.top);
                        }
                    }
                });
                synData.propPageDiv.find(".ppTable").remove();
                synData.propPageDiv.css({
                    "width": leftBound + "px",
                    "height": bottomBound + "px",
                    "min-width": "100%",
                    "min-height": "100%"
                });
                synData.propPageDiv.find(".ppStatic").each(function (index, value) {
                    synData.propPageDiv.prepend($(this));
                });
                // Fix button controls' height according to the input control. This has to be done
                // because textboxes cannot be assigned a pixel-perfect height, as height depends
                // on the font size etc.
                // Also, move buttons 1px to the left if they are adjacent to the input control
                for (let fieldName in synData.controls.controlsByFieldName) {
                    let coll = synData.controls.controlsByFieldName[fieldName];
                    if (coll.Input && coll.Button) {
                        let inputDOM = coll.Input.getDOMControl();
                        let buttonDOM = coll.Button.getDOMControl();
                        if ($.inArray(coll.Input.type, ["TextBoxInfo", "NumericTextBoxInfo", "DateTextBoxInfo",
                            "TimeTextBoxInfo", "DateAndTimeTextBoxInfo"]) >= 0) {
                            let inputHeight = inputDOM.outerHeight(false);
                            let buttonHeight = buttonDOM.outerHeight(false);
                            // If difference is too large, it may be on purpose
                            let diff = inputHeight - buttonHeight;
                            let diffAbs = Math.abs(diff);
                            if (diffAbs > 0 && diffAbs < 5) {
                                let borderTop = parseInt(buttonDOM.css("border-top-width"), 10);
                                let borderBottom = parseInt(buttonDOM.css("border-bottom-width"), 10);
                                diff = diff
                                    - (isNaN(borderTop) ? 0 : borderTop)
                                    - (isNaN(borderBottom) ? 0 : borderTop);
                                buttonDOM.css("height", buttonHeight + diff + "px");
                            }
                        }
                        let inputEnd = parseInt(inputDOM.css("left"), 10) + inputDOM.outerWidth(true);
                        let buttonLeft = parseInt(buttonDOM.css("left"), 10);
                        if ((inputEnd - buttonLeft) === 0)
                            buttonDOM.css("left", (buttonLeft - 1) + "px");
                    }
                }
            }
        }
        else {
            synData.propPageDiv.removeClass("ppAbsoluteLayout").addClass("ppTableLayout");
            let relevant = [];
            if (synData.controls) {
                $.each(synData.controls.controlsByFieldName, function (idx, coll) {
                    if (coll.Input)
                        relevant.push(coll);
                    for (let key in coll) {
                        if (coll.hasOwnProperty(key)) {
                            let elem = coll[key];
                            elem.setLayout("table");
                        }
                    }
                });
                relevant.sort(function (a, b) {
                    let tabIndexA = a.Input.tabOrder;
                    let tabIndexB = b.Input.tabOrder;
                    if (!tabIndexA) {
                        if (!tabIndexB)
                            return 0;
                        else
                            return 1;
                    }
                    else if (!tabIndexB)
                        return -1;
                    else {
                        let ia = parseInt(tabIndexA, 10);
                        let ib = parseInt(tabIndexB, 10);
                        return ((ia < ib) ? -1 : ((ia > ib) ? 1 : 0));
                    }
                });
                let table = $("<table class='ppTable'></table>");
                let colgroup = $("<colgroup></colgroup>").appendTo(table);
                let leftCol = $("<col class='leftCol' />").appendTo(colgroup);
                let rightCol = $("<col class='rightCol' />").appendTo(colgroup);
                $.each(relevant, function (idx, coll) {
                    let labelRow = $("<tr class='ppLabelRow'></tr>").appendTo(table);
                    let labelCell = $("<td colspan='2'></td>").appendTo(labelRow);
                    if (coll.Static) {
                        labelCell.append(coll.Static.getDOMControl());
                        if (coll.Static.visibleDynamic)
                            labelCell.removeClass("ppInvisibleDynamic").addClass("ppVisibleDynamic");
                        else
                            labelCell.removeClass("ppVisibleDynamic").addClass("ppInvisibleDynamic");
                    }
                    else
                        labelCell.css({ padding: "unset" }); // Wenn gar kein Static erzeugt werden soll, dann stört das Default-Padding mit 2x1px!
                    let controlRow = $("<tr class='ppControlRow'></tr>").appendTo(table);
                    let inputCell = $("<td class='inputCell'></td>").appendTo(controlRow);
                    if (coll.Input) {
                        if (coll.Input.visibleDynamic)
                            inputCell.removeClass("ppInvisibleDynamic").addClass("ppVisibleDynamic");
                        else
                            inputCell.removeClass("ppVisibleDynamic").addClass("ppInvisibleDynamic");
                        inputCell.append(coll.Input.getDOMControl());
                    }
                    else
                        inputCell.css({ padding: "unset" }); // Wenn gar kein Input erzeugt werden soll, dann stört das Default-Padding mit 2x1px!
                    if (coll.Button) {
                        let buttonCell = $("<td class='buttonCell'></td>").appendTo(controlRow);
                        if (coll.Button.visibleDynamic)
                            buttonCell.removeClass("ppInvisibleDynamic").addClass("ppVisibleDynamic");
                        else
                            buttonCell.removeClass("ppVisibleDynamic").addClass("ppInvisibleDynamic");
                        buttonCell.append(coll.Button.getDOMControl());
                    }
                    else
                        inputCell.attr("colspan", "2");
                });
                table.appendTo(synData.propPageDiv);
            }
        }
    }
    let ControlPropertyType;
    (function (ControlPropertyType) {
        ControlPropertyType[ControlPropertyType["Undefined"] = 0] = "Undefined";
        ControlPropertyType[ControlPropertyType["Top"] = 1] = "Top";
        ControlPropertyType[ControlPropertyType["Left"] = 2] = "Left";
        ControlPropertyType[ControlPropertyType["Width"] = 3] = "Width";
        ControlPropertyType[ControlPropertyType["Height"] = 4] = "Height";
        ControlPropertyType[ControlPropertyType["TabOrder"] = 5] = "TabOrder";
        ControlPropertyType[ControlPropertyType["ControlType"] = 6] = "ControlType";
        ControlPropertyType[ControlPropertyType["TextKey"] = 7] = "TextKey";
        ControlPropertyType[ControlPropertyType["DefValue"] = 8] = "DefValue";
        ControlPropertyType[ControlPropertyType["Visible"] = 9] = "Visible";
        ControlPropertyType[ControlPropertyType["ReadOnly"] = 10] = "ReadOnly";
        ControlPropertyType[ControlPropertyType["Multiline"] = 11] = "Multiline";
        ControlPropertyType[ControlPropertyType["AutoWrap"] = 12] = "AutoWrap";
        ControlPropertyType[ControlPropertyType["NotSetVisible"] = 13] = "NotSetVisible";
        ControlPropertyType[ControlPropertyType["FontHeight"] = 14] = "FontHeight";
        ControlPropertyType[ControlPropertyType["FontBold"] = 15] = "FontBold";
        ControlPropertyType[ControlPropertyType["FontItalic"] = 16] = "FontItalic";
        ControlPropertyType[ControlPropertyType["FontUnderline"] = 17] = "FontUnderline";
        ControlPropertyType[ControlPropertyType["FontStrikeOut"] = 18] = "FontStrikeOut";
        ControlPropertyType[ControlPropertyType["ImageDocId"] = 19] = "ImageDocId";
        ControlPropertyType[ControlPropertyType["VisibleDynamic"] = 20] = "VisibleDynamic";
    })(ControlPropertyType || (ControlPropertyType = {}));
    function ApplyLayoutDiff(layoutDiff, fac) {
        if ((layoutDiff) && (fac)) {
            $.each(layoutDiff, function (layoutDiffItemIndex, layoutDiffItem) {
                let control = fac.controlCollection.controlsByFieldName[layoutDiffItem.fieldName];
                if (control) {
                    let controlPart;
                    switch (layoutDiffItem.usage) {
                        case 1:
                            if (control.Input)
                                controlPart = control.Input;
                            break;
                        case 2:
                            if (control.Static)
                                controlPart = control.Static;
                            break;
                        case 3:
                            if (control.Button)
                                controlPart = control.Button;
                            break;
                        default:
                            break;
                    }
                    if (controlPart) {
                        let visibleDynamicValue = true;
                        let heightValue = 0;
                        let topValue = 0;
                        let bApplyVisibleDynamic = false;
                        let bApplyHeight = false;
                        let bApplyTop = false;
                        $.each(layoutDiffItem.values, function (layoutValueIndex, layoutValue) {
                            let value = layoutValue.value;
                            switch (layoutValue.propType) {
                                case ControlPropertyType.VisibleDynamic:
                                    bApplyVisibleDynamic = true;
                                    visibleDynamicValue = value;
                                    break;
                                case ControlPropertyType.Height:
                                    bApplyHeight = true;
                                    heightValue = value;
                                    break;
                                case ControlPropertyType.Top:
                                    bApplyTop = true;
                                    topValue = value;
                                    break;
                                default:
                                    break;
                            }
                        });
                        controlPart.applyLayoutAnimated(bApplyTop, topValue, bApplyHeight, heightValue, bApplyVisibleDynamic, visibleDynamicValue);
                    }
                }
            });
        }
    }
    function InitControls($this, propertyPage, tabindexOffset) {
        const synData = $this.data('synPropertyPage');
        if (!synData)
            return;
        let fac = new PropertyPageControls_1.ControlFactory(synData.propPageDiv, propertyPage.instance, synData.typeId, synData.modeFromServer, propertyPage.notNullFields, propertyPage.options, propertyPage.triggerFields);
        $.each(propertyPage.controls, function (index, controlDef) {
            // Add optional offset to tabindex
            if (typeof controlDef.tabOrder !== "undefined" && tabindexOffset)
                controlDef.tabOrder += tabindexOffset;
            fac.pushControl(controlDef);
        });
        if (propertyPage.options) {
            if (propertyPage.options.fontSize)
                synData.propPageDiv.css("font-size", propertyPage.options.fontSize);
            if (propertyPage.options.showBgImage && propertyPage.options.bgImageFile) {
                synData.propPageDiv.css("background-image", "url('" + Utilities_1.synUtil.getWSUrl("GetImage") + propertyPage.options.bgImageFile + "')");
                synData.propPageDiv.css("background-repeat", "no-repeat");
                let bgpos = "";
                if (propertyPage.options.bgStyle) {
                    switch (propertyPage.options.bgStyle) {
                        case "center":
                            bgpos = "center center";
                            break;
                        case "stretch":
                            synData.propPageDiv.css("background-size", "100% 100%");
                            break;
                        case "top":
                            bgpos = "center top";
                            break;
                        case "bottom":
                            bgpos = "center bottom";
                            break;
                        case "left":
                            bgpos = "left center";
                            break;
                        case "right":
                            bgpos = "right center";
                            break;
                        case "topLeft":
                            bgpos = "left top";
                            break;
                        case "topRight":
                            bgpos = "right top";
                            break;
                        case "bottomLeft":
                            bgpos = "left bottom";
                            break;
                        case "bottomRight":
                            bgpos = "right bottom";
                            break;
                        default:
                            synData.propPageDiv.css("background-repeat", "repeat");
                            break;
                    }
                }
                if (bgpos)
                    synData.propPageDiv.css("background-position", bgpos);
                if (propertyPage.options.bgFloat)
                    synData.propPageDiv.css("background-attachment", "fixed");
                else
                    synData.propPageDiv.css("background-attachment", "scroll");
                if (!propertyPage.options.bgTransparentStatics)
                    synData.propPageDiv.addClass("ppOpaqueStatics");
                else
                    synData.propPageDiv.removeClass("ppOpaqueStatics");
            }
            else {
                synData.propPageDiv.css("background-image", "");
                synData.propPageDiv.css("background-repeat", "");
                synData.propPageDiv.css("background-size", "");
                synData.propPageDiv.css("background-attachment", "");
                synData.propPageDiv.css("background-position", "");
                synData.propPageDiv.removeClass("ppOpaqueStatics");
            }
        }
        synData.controls = fac.create();
        synData.controlFactory = fac;
        synData.controlFactory.onTriggerFieldChanged = function (changedInstance) {
            synData.controlFactory.updateOldTriggerFieldValues(changedInstance);
            let requestGUID = Utilities_1.synUtil.getGUID(true);
            let requestOptions = {
                instanceData: JSON.stringify(changedInstance.toJSON()),
            };
            requestOptions.mode = synData.modeFromServer;
            requestOptions.requestGUID = requestGUID;
            Utilities_1.synUtil.beginAjaxProgress();
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("PropertypageControlsDiff"),
                requestData: requestOptions,
                done(responseData) {
                    if (responseData) {
                        if (responseData.responseGUID === requestGUID) {
                            // Response entspricht dem AKTUELLSTEN Request. Alle anderen Responses können und müssen ignoriert werden.
                            // Ansonsten kanns passieren, dass ein eigentlich älterer Response hier auf die Controls übernommen wird und dann
                            // aber nicht den Werten in den Controls entspricht!
                            if ((responseData.items) && (responseData.items.length > 0)) {
                                ApplyLayoutDiff(responseData.items, fac);
                                window.waitConditions.set("propertyPageDiffApplied");
                            }
                        }
                    }
                    Utilities_1.synUtil.endAjaxProgress();
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.endAjaxProgress();
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, this.url, true);
                }
            });
        };
        synData.controlFactory.onChange = function (changedFields, changedInstance, manualChange) {
            let ddl = synData.versionDropDown;
            if (changedFields && changedFields.length) {
                SetUnsavedChanges($this, changedFields, changedInstance);
                $this.trigger("valuesChanged", [changedFields, changedInstance]);
                if (manualChange)
                    $this.trigger("valuesChangedManually", [changedFields, changedInstance]);
            }
            else {
                DeleteUnsavedChanges($this, fac.getCurrentInstance());
                $this.trigger("valuesReverted");
                if (manualChange)
                    $this.trigger("valuesRevertedManually");
            }
            if (ddl)
                ddl.enable(!changedFields || !changedFields.length);
        };
        synData.controlFactory.onFullRefresh = function () {
            $this.synPropertyPage("refresh");
        };
        synData.controlFactory.onControlChange = function (changedControl) {
            $this.trigger("controlChanged", [changedControl]);
        };
        synData.controlFactory.onControlRecreated = function (recreatedControl) {
            $this.trigger("controlRecreated", [recreatedControl]);
        };
        synData.controlFactory.onSearch = function () {
            $this.trigger("search");
        };
        synData.controlFactory.onFtFieldChange = function (changedInstance) {
            if (synData.modeFromServer === Base_1.PropertyPageMode.Edit || synData.modeFromServer === Base_1.PropertyPageMode.New) {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: synData.PropertypageMandatoryFieldsWsUrl,
                    requestData: {
                        mode: synData.modeFromServer,
                        instanceData: JSON.stringify([changedInstance.toJSON()])
                    },
                    done(notNullFields) {
                        SetNotNullFields($this, notNullFields);
                    }
                });
            }
        };
        synData.controlFactory.onBoolFieldChange = function (changedInstance) {
            if (synData.modeFromServer === Base_1.PropertyPageMode.Edit || synData.modeFromServer === Base_1.PropertyPageMode.New) {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: synData.PropertypageMandatoryFieldsWsUrl,
                    requestData: {
                        mode: synData.modeFromServer,
                        instanceData: JSON.stringify([changedInstance.toJSON()])
                    },
                    done(notNullFields) {
                        SetNotNullFields($this, notNullFields);
                    }
                });
            }
        };
        SetNotNullFields($this, propertyPage.notNullFields);
        if (propertyPage.notNullFieldsErrorFormat)
            synData.notNullFieldsErrorFormat = propertyPage.notNullFieldsErrorFormat;
        else
            synData.notNullFieldsErrorFormat = "{0}";
        ApplyLayout($this);
        synData.propertyPageOptions = propertyPage.options;
        $this.trigger("controlsInitialized");
    }
    function SetUnsavedChanges($this, changedFields, changedInstance) {
        const synData = $this.data("synPropertyPage");
        if (synData.checkForUnsavedChanges) {
            let changeSet = new Instance_1.Instance();
            for (let i = 0; i < changedFields.length; ++i) {
                let prop = changedFields[i];
                let control;
                if (synData.controls.controlsByFieldName[prop])
                    control = synData.controls.controlsByFieldName[prop].Input || undefined;
                if (control == undefined || !control.field.isFTRepresentativeField)
                    changeSet.items[prop] = changedInstance.items[prop].clone();
            }
            let storageKey = GetSessionStorageKey($this, changedInstance);
            if (storageKey == undefined)
                return;
            sessionStorage.setItem(storageKey + "_unsaved", JSON.stringify(changeSet.toJSON()));
            sessionStorage.setItem(storageKey + "_timestamp", JSON.stringify(new Date().getTime()));
            if (synData.modeFromServer === Base_1.PropertyPageMode.Edit)
                sessionStorage.setItem(storageKey + "_etag", changedInstance.items["cgdocument.etag"].valueAsString);
        }
    }
    function CheckForUnsavedChanges($this) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = $this.data("synPropertyPage");
            if (synData && synData.checkForUnsavedChanges) {
                let instance = $this.synPropertyPage("getInstance");
                let storageKey = GetSessionStorageKey($this, instance);
                if (storageKey != undefined) {
                    let val = sessionStorage.getItem(storageKey + "_unsaved");
                    if (val != undefined) {
                        let timeStamp = sessionStorage.getItem(storageKey + "_timestamp");
                        if (timeStamp != undefined && (+new Date() - JSON.parse(timeStamp)) <= 7200000) {
                            let instanceJSON = JSON.parse(val);
                            instanceJSON.items["cgdocument.typeid"] = instance.items["cgdocument.typeid"].value; // fromJSON benötigt die typeid
                            // Kleiner hack: hier sollen wirklich nur die Items in die Instanz aufgenommen werden, die im SessionStorage als geänderte Items enthalten waren.
                            // Ansonsten wird die Instanz hier mit Leerwerten aufgefüllt, was dann zu unnötiger und vermutlich auch fehlerhafter Wiederherstellung von unsaved changes führen würde.
                            instanceJSON["skipAddEmptyFields"] = true;
                            let changeSet = yield Instance_1.Instance.fromJSON(instanceJSON);
                            let unsavedChanges = false;
                            for (let prop in changeSet.items) {
                                let origProp = instance.items[prop];
                                if (!origProp)
                                    continue;
                                if (origProp.value !== changeSet.items[prop].value) {
                                    unsavedChanges = true;
                                    break;
                                }
                            }
                            if (!unsavedChanges)
                                return;
                            if (synData.modeFromServer === Base_1.PropertyPageMode.Edit) {
                                let etag = sessionStorage.getItem(storageKey + "_etag");
                                if (etag == undefined || instance.items["cgdocument.etag"].value !== etag) {
                                    ApplyUnsavedChanges($this, changeSet, false);
                                    $this.trigger("unsavedChangesObsolete", [instance.items["cgdocument.etag"].value]);
                                    return;
                                }
                            }
                            else if (synData.modeFromServer !== Base_1.PropertyPageMode.New)
                                return;
                            ApplyUnsavedChanges($this, changeSet);
                        }
                    }
                }
            }
        });
    }
    function ApplyUnsavedChanges($this, changeSet, notify = true) {
        $this.synPropertyPage("changeInstance", changeSet);
        if (notify)
            Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("synappliedunsavedchanges"));
    }
    function DeleteUnsavedChanges($this, changedInstance) {
        const synData = $this.data("synPropertyPage");
        if (synData.checkForUnsavedChanges) {
            let storageKey = GetSessionStorageKey($this, changedInstance);
            if (storageKey != undefined) {
                sessionStorage.removeItem(storageKey + "_unsaved");
                sessionStorage.removeItem(storageKey + "_timestamp");
                sessionStorage.removeItem(storageKey + "_etag");
            }
        }
    }
    function GetSessionStorageKey($this, changedInstance) {
        const synData = $this.data("synPropertyPage");
        if (synData.modeFromServer === Base_1.PropertyPageMode.Edit) {
            if (!changedInstance || !changedInstance.id)
                return undefined;
            return changedInstance.id.value;
        }
        else if (synData.modeFromServer === Base_1.PropertyPageMode.New)
            return synData.typeId.toString() + "_" + (synData.parentId || "");
        return undefined;
    }
    function SetNotNullFields($this, notNullFields) {
        const synData = $this.data('synPropertyPage');
        synData.notNullFields = notNullFields;
        // Reset mandatory state of all controls
        $.each(synData.controls.allControls, (idx, control) => {
            if (control instanceof PropertyPageControls_1.FieldControl)
                control.setMandatory(false);
        });
        $.each(notNullFields, function (idx, notnullfield) {
            let coll = synData.controls.controlsByFieldName[notnullfield];
            if (coll) {
                if (coll.Input && coll.Input instanceof PropertyPageControls_1.FieldControl)
                    coll.Input.setMandatory(true);
            }
            else {
                coll = synData.controls.controlsByPresentedFieldName[notnullfield];
                if (coll) {
                    $.each(coll, function (idx2, representativeColl) {
                        if (representativeColl.Input && representativeColl.Input instanceof PropertyPageControls_1.FieldControl) {
                            let fc = representativeColl.Input;
                            let setFunc = fc.setMandatory.bind(fc, true);
                            setFunc(true);
                        }
                    });
                }
            }
        });
    }
    function SetValuesToControls($this, instance) {
        const synData = $this.data('synPropertyPage');
        if (instance)
            synData.controlFactory.setNewInstance(instance);
    }
    function SetVersions($this, instance) {
        const synData = $this.data('synPropertyPage');
        if (instance && synData && synData.versionsDiv.css("display") !== "none") {
            let ddlOld = synData.versionDropDown;
            if (ddlOld)
                ddlOld.destroy();
            synData.versionsDiv.html("");
            let thisVersion = {
                version: instance.items["cgdocument.version"].valueToString(),
                verComment: instance.items["cgdocument.vercomment"].value,
                verCur: instance.items["cgdocument.vercur"].value
            };
            let select = $("<select class='ppVerSelect'><option value='" + thisVersion.version + "'></option></select>")
                .appendTo(synData.versionsDiv);
            let versionHeaderTemplate = "<span class='ppVSVersion #= (data.verCur? \'ppVerCur\' : \'ppOldVer\')#'>v#: data.version #</span><span class='ppVSVerComment'>#: data.verComment || \'\'#</span>";
            let changeHeader = function (combo, dataItem) {
                let template = kendo.template(versionHeaderTemplate);
                combo.span.html(template(dataItem));
            };
            let ddl = select.kendoDropDownList({
                autoBind: false,
                template: versionHeaderTemplate,
                dataTextField: "text",
                dataValueField: "version",
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read(options) {
                            Utilities_1.synUtil.getAJAXData({
                                url: Utilities_1.synUtil.getWSUrl("InstanceVersions") + instance.id.value,
                                done(data) {
                                    data.sort(function (a, b) { return b.version - a.version; });
                                    options.success($.map(data, function (elem) {
                                        return {
                                            verComment: elem.verComment,
                                            version: elem.version.toString(),
                                            verCur: elem.verCur
                                        };
                                    }));
                                }
                            });
                        }
                    }
                }),
                dataBound(e) {
                    changeHeader(e.sender, e.sender.dataItem());
                },
                change(e) {
                    changeHeader(e.sender, e.sender.dataItem());
                },
                select(e) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let combo = e.sender;
                        let dataItem = combo.dataItem(e.item.index());
                        let inst = $this.synPropertyPage("getInstance");
                        yield $this.synPropertyPage("setInstance", {
                            id: inst.id.value + "|" + dataItem.version,
                            mode: synData.initialMode,
                            verCur: dataItem.verCur
                        });
                    });
                }
            }).data("kendoDropDownList");
            changeHeader(ddl, thisVersion);
            // Enable Dropdown only if more versions exist
            let moreVersions = (thisVersion.version !== "1" || !thisVersion.verCur);
            ddl.enable(moreVersions);
            ddl.span.next(".k-select").css("display", (moreVersions ? "" : "none"));
            synData.versionDropDown = ddl;
        }
    }
})(jQuery);
